import { render, staticRenderFns } from "./EventCollapsableDescriptionComponent.vue?vue&type=template&id=1921c7e2&scoped=true&"
import script from "./EventCollapsableDescriptionComponent.vue?vue&type=script&lang=js&"
export * from "./EventCollapsableDescriptionComponent.vue?vue&type=script&lang=js&"
import style0 from "./EventCollapsableDescriptionComponent.vue?vue&type=style&index=0&id=1921c7e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1921c7e2",
  null
  
)

export default component.exports